import { Button, Empty, Flex, Spin, Typography } from 'antd'
import React, { useEffect, useState } from 'react'

import { BillableActionService, type BillablesByItem } from '@services/BillableActionService'
import { useConfirmation } from '@store/confirmation'

import type { Creator } from '../../../../../types'

import { BillableActionsTable } from './BillableActionsTable'

export const BillablesTab = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [selectedCreator, setSelectedCreator] = useState<Creator>()
    const [billablesByItem, setBillablesByItem] = useState<BillablesByItem>()
    const confirm = useConfirmation()

    const fetchBillables = async () => {
        if (selectedCreator) {
            setIsLoading(true)
            try {
                const results = await BillableActionService.listByCreator(selectedCreator.id)

                setBillablesByItem(results)
            } catch (err) {
                console.error('Unable to retrieve reports info')
            } finally {
                setIsLoading(false)
            }
        }
    }

    useEffect(() => {
        fetchBillables()
    }, [selectedCreator])

    const markAllBilled = async () => {
        if (
            await confirm({
                title: 'Are you sure you want to mark these actions billed?'
            })
        ) {
            try {
                if (!selectedCreator) {
                    throw new Error('Selected creator does not exist')
                }
                await BillableActionService.markBilled(selectedCreator.id)

                fetchBillables()
            } catch (err) {
                console.error('Unable to mark all billed')
            }
        }
    }

    useEffect(() => {
        const fetchCreators = async () => {
            try {
                setIsLoading(true)
                const results = await BillableActionService.getBilledCreators()

                // Only supporting the first billed creator so far
                if (results.length === 1) {
                    setSelectedCreator(results[0])
                } else if (results.length > 1) {
                    throw new Error("There's more than one billable creator. Refactor this code!")
                }
            } catch (err) {
                console.error(err)
            } finally {
                setIsLoading(false)
            }
        }

        fetchCreators()
    }, [])

    if (isLoading) {
        return <Spin />
    }
    if (!selectedCreator || !billablesByItem || Object.entries(billablesByItem).length === 0) {
        return <Empty />
    }

    return (
        <>
            <Flex align="center" gap="large">
                <Typography.Title>{selectedCreator.name}</Typography.Title>{' '}
                <Button onClick={markAllBilled} type="primary">
                    Mark Billed
                </Button>
            </Flex>
            {Object.entries(billablesByItem).map(([itemKey, billableActions]) => (
                <React.Fragment key={itemKey}>
                    <BillableActionsTable name={itemKey as 'NZ' | 'EN'} billableActions={billableActions} />
                </React.Fragment>
            ))}
        </>
    )
}
